/* eslint-disable*/
//
// traceit-Reactjs v1.0 is an add-on pluging for React.
//
// (c) NGAP Team,  2019 Finablr 

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof window.self!=="undefined"){g=window.self}else{g=this}g.traceit__react = f()}})(function(){var define,module,exports;
var _$traceit_plugin = {};
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

_$traceit_plugin = {
  name: 'react',
  init: function (client, React) {
    if (React === void 0) {
      React = window.React;
    }

    if (!React) throw new Error('cannot find React');

    var traceit =
    /*#__PURE__*/
    function (_React$Component) {
      _inheritsLoose(traceit, _React$Component);

      function traceit(props) {
        var _this;

        client.setOptions({ beforeSend: props.beforeSend })
        _this = _React$Component.call(this, props) || this;
        _this.state = {
          error: null,
          info: null
        };
        return _this;
      }

      var _proto = traceit.prototype;

      _proto.componentDidCatch = function componentDidCatch(error, info) {
        var beforeSend = this.props.beforeSend;
        var TraceitReport = client.TraceitReport;
        var handledState = {
          severity: 'error',
          unhandled: true,
          severityReason: {
            type: 'unhandledException'
          }
        };
        var report = new TraceitReport(error.name, error.message, TraceitReport.getStacktrace(error), handledState);
        if (info && info.componentStack) info.componentStack = formatComponentStack(info.componentStack);
        report.updateMetaData('react', info);
        client.notify(report, {
          beforeSend: beforeSend
        });
        this.setState({
          error: error,
          info: info
        });
      };

      _proto.render = function render() {
        var error = this.state.error;

        if (error) {
          var FallbackComponent = this.props.FallbackComponent;
          if (FallbackComponent) return React.createElement(FallbackComponent, this.state);
          return null;
        }

        return this.props.children;
      };

      return traceit;
    }(React.Component);

    return traceit;
  }
};

var formatComponentStack = function (str) {
  var lines = str.split(/\s*\n\s*/g);
  var ret = '';

  for (var line = 0, len = lines.length; line < len; line++) {
    if (lines[line].length) ret += "" + (ret.length ? '\n' : '') + lines[line];
  }

  return ret;
};

_$traceit_plugin.formatComponentStack = formatComponentStack;
_$traceit_plugin['default'] = _$traceit_plugin;

return _$traceit_plugin;

});







